import React from 'react'
import PropTypes from 'prop-types'
import _ from 'underscore'

const VALIDPHPVERSION = "7.3"
const VALIDWPVERSION = "5.5.3"

class WPEngineLoader extends React.Component {
	constructor(props) {
		super(props)
		let migrate = props.migrate
		this.state = {
			sitePhpVersion: migrate.get('site_php_version'),
			siteWPVersion: migrate.get('site_wpversion'),
			isSiteMultisite: migrate.get('is_site_multisite')
		}
	}
	componentDidMount() {
		const { close } = this.props
		const { sitePhpVersion, siteWPVersion, isSiteMultisite } = this.state
		let warnings = [sitePhpVersion, siteWPVersion, isSiteMultisite]
		if (_.every(warnings, _.isNull)) {
			close()
		}
	}
	customHtaccess = () => {
		return <div className="p-4 bg-warning mb-15">
			<b>Custom .htaccess setting</b> Your site has custom .htaccess settings.
			You will need to contact WP Engine support to have these settings applied after the migration
			is completed.
			<a href="https://wpengine.com/support/htaccess/" target="_blank" rel="noopener noreferrer" className="v-center">
				&nbsp;Learn about about .htaccess settings&nbsp; <img src="/assets/wpengine/link-icon.svg"/>
			</a>
		</div>
	}
	unsupportedPhpVersion = (version) => {
		return <div className="p-4 bg-warning mb-15">
			<b>Unsupported PHP version</b> Your current PHP version is {version}. WP Engine only supports version {VALIDPHPVERSION} or newer.
			Please update before continuing.
			<a href="https://wpengine.com/support/php-guide/" target="_blank" rel="noopener noreferrer" className="v-center">
				&nbsp;Learn more about PHP versions&nbsp; <img src="/assets/wpengine/link-icon.svg"/>
			</a>
		</div>
	}
	unsupportedWPVersion = (version) => {
		return <div className="p-4 bg-warning mb-15">
			<b>Unsupported Wordpress version</b>
			{' '}Your current Wordpress version is {version}. WP Engine only supports version {VALIDWPVERSION} or newer. Please update before continuing.
			<a href="https://wpengine.com/support/wordpress-updates/" target="_blank" rel="noopener noreferrer" className="v-center">
				&nbsp;Learn more about Wordpress Versions&nbsp; <img src="/assets/wpengine/link-icon.svg"/>
			</a>
		</div>
	}
	multisiteEnabled = () => {
		return <div className="p-4 bg-warning mb-15">
			<b>Multisite enabled</b> This environment has multisite enabled.
			Ensure that multisite is included with your hosting plan before continuing.
			<a href="https://wpengine.com/support/what-is-wordpress-multisite/" target="_blank" rel="noopener noreferrer" className="v-center">
				&nbsp;Learn more about Multisite&nbsp; <img src="/assets/wpengine/link-icon.svg"/>
			</a>
		</div>
	}
	warningsList = () => {
		const { migrate } = this.props
		const { sitePhpVersion, siteWPVersion, isSiteMultisite} = this.state
		let content = []
		sitePhpVersion < VALIDPHPVERSION && content.push(this.unsupportedPhpVersion(sitePhpVersion))
		siteWPVersion < VALIDWPVERSION && content.push(this.unsupportedWPVersion(siteWPVersion))
		isSiteMultisite && content.push(this.multisiteEnabled())
		return content
	}
	buttons = (warningsCount) => {
		const { history, close } = this.props
		let migrateText = warningsCount ? 'Continue with migration' : 'Migrate'
		let backBtnClass = warningsCount ? 'primary-button width33' : 'secondary-button'
		let migrateBtnClass = warningsCount ? 'secondary-button' : 'primary-button'
		return <div className="row justify-content-end mt-3">
			<div className="col-sm-6 col-sm-offset-6 d-flex justify-content-between">
				<button className={`button ${backBtnClass}`} onClick={() => history.toJS().goBack()}>Back</button>
				<button type="submit" className={`button ${migrateBtnClass}`} onClick={() => close()}>{migrateText}</button>
			</div>
		</div>
	}
	render() {
		let warningsList = this.warningsList()
		let warningsCount = warningsList.length
		return <div className="wpe">
			<div className="migration-readiness-page">
				<div className="container">
					<div className="row align-items-center mb-3">
						<div className="col-sm-12">
							<h3>Migration Readiness</h3>
						</div>
					</div>
					{ warningsCount ? <React.Fragment>
						<div className="row align-items-center">
							<div className="col-sm-10 mb-1">
								<h5>{warningsCount} potential issues</h5>
								<p>These issues often cause problems after migrating. We recommend that you address these issues before continuing.</p>
							</div>
						</div>
						<div className="row align-items-center">
							<div className="col-sm-12">{warningsList}</div>
						</div>
						</React.Fragment> : <div className="row align-items-center">
						<div className="col-sm-12 text-center">
							<h5>Your site looks ready to migrate</h5>
						</div>
					</div> }
					{this.buttons(warningsCount)}
				</div>
			</div>
		</div>
	}
}

WPEngineLoader.propTypes = {
	history: PropTypes.object,
	close: PropTypes.func
}

export default WPEngineLoader
